// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, browser:true, react:true*/
import React, {createContext, useContext} from 'react';
import {i_plus_context_store} from './plus_types';
// @ts-ignore
import plans_util from '/www/hola/pub/plans_util.js';

const Plus_context = createContext<i_plus_context_store | null>(null);

interface i_plus_store_provider_props {
    children: JSX.Element;
    value: i_plus_context_store;
    key?: React.Key;
}

export const Plus_store_provider = ({children, value, ...props}:
    i_plus_store_provider_props)=>{
    // XXX mikita: useState eventually, when provider context will be
    // responsible for business logic => data mutation
    const {best, popular} = plans_util.get_special_plans(value.plans);
    const provider_value = {
        ...value,
        best_id: best?.id,
        popular_id: popular?.id,
    };
    return <Plus_context.Provider {...props} value={provider_value}>{children}
    </Plus_context.Provider>;
};

export const use_plus_store = (): i_plus_context_store=>{
    const context = useContext(Plus_context);
    if (context === null)
    {
        throw new Error('use_plus_store should be called inside '
        +'Plus_store_provider!');
    }
    return context;
};
